import { render, staticRenderFns } from "./ProblemInputForm.vue?vue&type=template&id=4ceac874&scoped=true&"
import script from "./ProblemInputForm.vue?vue&type=script&lang=js&"
export * from "./ProblemInputForm.vue?vue&type=script&lang=js&"
import style0 from "./ProblemInputForm.vue?vue&type=style&index=0&id=4ceac874&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ceac874",
  null
  
)

export default component.exports